import { useRef, useEffect } from 'react';

// Control if the component is mounted
export default function useMounted() {
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => (mounted.current = false);
  }, []);

  return mounted;
}
